import { useState } from 'react'
import type { AnswerInputProps } from '../QuestionRenderer'

const countries = [
  ['🇹🇼', '+886'],
  ['🇺🇸', '+1'],
  ['🇯🇵', '+81'],
  ['🇨🇳', '+86'],
]

export function PhoneInput({ question, value, onChange, onSubmit }: AnswerInputProps<string>) {
  const [code, setCode] = useState('+886')
  const number = value?.replace(code, '').trim() ?? ''

  return (
    <div className="flex flex-col gap-2">
      <div className="flex gap-2">
        <select
          value={code}
          onChange={(event) => {
            setCode(event.target.value)
            onChange(`${event.target.value} ${number}`.trim())
          }}
          className="h-12 rounded-md border border-slate-200 bg-white px-3"
        >
          {countries.map(([flag, prefix]) => (
            <option key={prefix} value={prefix}>
              {flag} {prefix}
            </option>
          ))}
        </select>
        <input
          value={number}
          pattern={
            typeof question.settings.validationRegex === 'string'
              ? question.settings.validationRegex
              : undefined
          }
          onChange={(event) => onChange(`${code} ${event.target.value}`.trim())}
          onKeyDown={(event) => {
            if (event.key === 'Enter') onSubmit()
          }}
          className="h-12 min-w-0 flex-1 rounded-md border border-slate-200 bg-white px-3 outline-none focus:border-indigo-500"
          placeholder="912 345 678"
        />
      </div>
      {question.settings.errorMessage ? (
        <div className="text-sm text-rose-500">{question.settings.errorMessage}</div>
      ) : null}
    </div>
  )
}
